import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ConfigServiceService, ItemSidebar } from '../config-service/config-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private router: Router, private configurationService: ConfigServiceService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const storedUser = localStorage.getItem("einvuser");
    let info: { access_token?: string } | null = null;

    if (storedUser) {
      try {
        info = JSON.parse(storedUser);
      } catch {
        localStorage.removeItem("einvuser");
      }
    }
    /*this.navigatorConfig = await (await this.configurationService.getJSON()).configSidebar;
    let check : any = this.navigatorConfig.filter(i => state.url.startsWith("/main/" + i.url)).length==0 || this.navigatorConfig.filter(i => state.url.startsWith("/main/" + i.url) && i.allow.includes(info!.role)).length > 0;
    if(!check){
      check = this.router.parseUrl('/main/dashboard');
    }
    return check;*/
    if (info?.access_token)  {
      return true;
    } else {
      return this.router.parseUrl('/Login');
    }
  }
}
